import Button, { ButtonProps } from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
import { CustomIconFromValue } from '@app/components'
import { Box } from '@mui/material'

interface CustomActionButtonProps extends ButtonProps {
	icon?: string
	onClick?: () => void
	href?: string
	children?: React.ReactNode
}

export function CustomActionButton({
	children,
	icon,
	onClick,
	href,
	...otherProps
}: CustomActionButtonProps) {
	const theme = useTheme()
	const color = (otherProps.sx as any)?.color as string

	return (
		<Button
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				cursor: 'pointer',
				border: `solid 1.5px ${
					otherProps.disabled
						? theme.palette.grey[400]
						: theme.palette.primary.main
				}`,
				color: color ?? theme.palette.primary.main,
				paddingLeft: 0,
				paddingBottom: 0,
				paddingTop: 0,
				position: 'relative',
				height: '28px',
				width: '145px',
				fontSize: '12px',
				borderRadius: '2px',
			}}
			onClick={href ? undefined : onClick}
			href={href}
			{...otherProps}
		>
			{icon && (
				<Box
					sx={{
						marginLeft: '2px',
					}}
				>
					<CustomIconFromValue
						icon={icon}
						color={color}
						style={{
							color:
								color ?? otherProps.disabled
									? theme.palette.grey[400]
									: theme.palette.primary.main,
							display: 'flex',
							alignItems: 'center',
						}}
					/>
				</Box>
			)}
			<Box
				display="flex"
				justifyContent="center"
				flexGrow="1"
				mx={2}
				sx={{
					color:
						color ?? otherProps.disabled
							? theme.palette.grey[400]
							: theme.palette.primary.main,
				}}
			>
				{children}
			</Box>
		</Button>
	)
}
